import React from 'react';

import { ActionIcon } from '@good/ui/core';
import { Plus } from '@good/icons';
import { rosterConfig } from '../../roster-config';

export type OnAddBooking = ({
  customerId,
  startDateTime,
}: { customerId: string; startDateTime?: Date }) => Promise<void>;

interface AddBookingPopoverProps {
  offsetX: number;
  onAddBooking: () => Promise<void>;
}

export const AddBookingPopover = ({ offsetX, onAddBooking }: AddBookingPopoverProps) => (
  <div className='position-absolute' style={{ top: 4, left: offsetX }}>
    <ActionIcon
      opacity={0.6}
      style={{ zIndex: 9 }}
      w={rosterConfig.TIMELINE_HOUR_BLOCK_WIDTH - 8}
      variant='default'
      h={rosterConfig.TIMELINE_CARD_HEIGHT}
      onClick={onAddBooking}
    >
      <Plus />
    </ActionIcon>
  </div>
);
